import { mixpanel } from '@fiverr-private/obs';

const profileImageClicked = (params) => {
    mixpanel.track('Profile image clicked', params);
};

export {
    profileImageClicked
};
